import ReadReview from '@components/partials/svg/readReview';
import Trending from '@components/partials/svg/trending';
import styles from '@styles/scss/site/card.module.scss';
import { windowWidth } from 'lib/helper/windowWidth';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { parseCookies } from 'nookies';
import { useEffect, useState } from 'react';

export default function SiteCard({
    site,
    siteIndex,
    categoryName,
    categorySlug,
    isCategory,
    buttonText
}: {
    site: any;
    siteIndex: number;
    categoryName: string;
    categorySlug: string;
    isCategory?: boolean;
    buttonText: string;
}): JSX.Element {
    const [showToolTip, setToolTip] = useState({ sitePos: 0, isDesktop: false });
    const width = windowWidth();
    useEffect(() => {
        if (width > 780) {
            setToolTip({ ...showToolTip, ...{ isDesktop: true } });
        } else {
            setToolTip({ ...showToolTip, ...{ isDesktop: false } });
        }
    }, [width]);

    const cookies = parseCookies();
    const [updatedTourlink, setTourlink] = useState(site.tourlink);
    useEffect(() => {
        if (cookies.u) {
            setTourlink(site.tourlink.replace('{exid}', cookies.u));
        }
    }, [cookies.u]);

    const externalLink = site.useOpensite ? '/out/' + site.slug : updatedTourlink;
    const internalLink = `/${site.categorySlug ? site.categorySlug : categorySlug}/${site.slug}`;

    const router = useRouter();

    return (
        <>
            <div
                className={
                    router.asPath.includes(internalLink)
                        ? styles.card + ' ' + styles.active
                        : styles.card
                }>
                <div
                    className={styles.header}
                    style={site.isTrending ? { backgroundColor: '#eeeef8' } : undefined}>
                    <div className={styles.position}>{siteIndex}.</div>
                    <Link
                        prefetch={false}
                        href={!site.isReviewActive ? externalLink : internalLink}>
                        {!site.isReviewActive ? (
                            <a
                                target="_blank"
                                rel={
                                    site.useOpensite
                                        ? 'nofollow noopener noreferrer'
                                        : 'noopener noreferrer'
                                }>
                                <div
                                    className={styles.icon}
                                    style={{ backgroundPosition: site.icon }}></div>
                                <h3>{site.name}</h3>
                            </a>
                        ) : (
                            <a>
                                <div
                                    className={styles.icon}
                                    style={{ backgroundPosition: site.icon }}></div>
                                <h3>{site.name}</h3>
                            </a>
                        )}
                    </Link>
                    {site.isReviewActive && (
                        <Link prefetch={false} href={internalLink}>
                            <a
                                className={styles.reviewButton}
                                onMouseOver={() =>
                                    setToolTip({ ...showToolTip, ...{ sitePos: siteIndex } })
                                }
                                onMouseOut={() => setToolTip({ ...showToolTip, ...{ sitePos: 0 } })}
                                onFocus={() =>
                                    setToolTip({ ...showToolTip, ...{ sitePos: siteIndex } })
                                }
                                onBlur={() => setToolTip({ ...showToolTip, ...{ sitePos: 0 } })}>
                                <ReadReview />
                            </a>
                        </Link>
                    )}
                    {site.isTrending && (
                        <div className={styles.trendingIcon}>
                            <Trending />
                        </div>
                    )}
                    <div
                        className={`${styles.tooltip} ${
                            showToolTip.sitePos === siteIndex && showToolTip.isDesktop
                                ? styles.visible
                                : styles.hidden
                        }`}>
                        {`Read ${site.name} Review`}
                    </div>
                </div>
                <Link prefetch={false} href={!site.isReviewActive ? externalLink : internalLink}>
                    {!site.isReviewActive ? (
                        <a
                            data-site-name={site.name}
                            data-site-category={categoryName}
                            target="_blank"
                            rel={site.useOpensite ? 'nofollow noreferrer' : 'noreferrer'}>
                            <Image
                                className={styles.siteImg}
                                src={site.image}
                                alt={site.name}
                                width={378}
                                height={113}
                                unoptimized={true}
                                objectFit="cover"
                            />
                        </a>
                    ) : (
                        <a>
                            <Image
                                className={styles.siteImg}
                                src={site.image}
                                alt={site.name}
                                width={378}
                                height={113}
                                unoptimized={true}
                                objectFit="cover"
                            />
                        </a>
                    )}
                </Link>
                {isCategory && (
                    <div
                        className={styles.description}
                        dangerouslySetInnerHTML={{ __html: site.miniDescription }}></div>
                )}
                <Link prefetch={false} href={externalLink}>
                    <a
                        className={`${styles.siteLink} ${
                            isCategory ? undefined : styles.siteLinkExtraMargin
                        }`}
                        data-site-name={site.name}
                        data-site-category={categoryName}
                        target="_blank"
                        rel={
                            site.useOpensite
                                ? 'nofollow noopener noreferrer'
                                : 'noopener noreferrer'
                        }>
                        {buttonText.replace('%SITE_NAME%', site.name)}
                    </a>
                </Link>
            </div>
        </>
    );
}
